import api from "@/apis/AssetCategoryAPI";
import Crud from "./crud-base";
var crud = new Crud("AssetCategory", api);
import httpClient from "@/apis/base/axios-httpclient";

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "AssetCategoryID",
      name: "AssetCategoryName",
      code: "AssetCategoryCode",
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Load danh sách
   */
  async getAllAssetCategory(context, payload) {
    //context.commit("updateLoading", true);

    let res = await api.getAllAssetCategory();
    //context.commit("updateLoading", false);

    if (res) {
      // res.skip = payload ? payload.skip : 0;
      res.payload = payload;
      context.commit("setAllItems", res);
    }

    return res;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
